import { isFullyInside } from './layout';
import { isFilterWidget } from './widgetTypes';

export function isContainerWidget(widget) {
  if (!widget || typeof widget !== 'object') {
    return false;
  }

  if (widget.type === 'container' || widget.widget === 'container') {
    return true;
  }

  if (widget.isContainer === true) {
    return true;
  }

  if (widget.data && widget.data.isContainer === true) {
    return true;
  }

  if (widget.data && widget.data.container === true) {
    return true;
  }

  return false;
}

function getContainers(widgets) {
  return (widgets || []).filter(isContainerWidget);
}

function getContainerIdsForWidget(widget, containers) {
  var result = [];

  containers.forEach(function (container) {
    if (isFullyInside(container, widget)) {
      result.push(container.id);
    }
  });

  return result;
}

function collectMergedFilterParams(filterWidgetIds, filterValuesByWidgetId) {
  return filterWidgetIds.reduce(function (acc, widgetId) {
    var widgetFilters = filterValuesByWidgetId[widgetId];
    if (!widgetFilters || typeof widgetFilters !== 'object') {
      return acc;
    }

    return {
      ...acc,
      ...widgetFilters
    };
  }, {});
}

export function buildFilterScopes(widgets) {
  var containers = getContainers(widgets);

  var widgetScopeMap = {};
  (widgets || []).forEach(function (widget) {
    widgetScopeMap[widget.id] = getContainerIdsForWidget(widget, containers);
  });

  return {
    containers,
    widgetScopeMap
  };
}

export function getMergedFilterParamsForWidget(targetWidget, widgets, filterValuesByWidgetId) {
  if (!targetWidget || isFilterWidget(targetWidget)) {
    return {};
  }

  var scopes = buildFilterScopes(widgets);
  var targetContainerIds = scopes.widgetScopeMap[targetWidget.id] || [];

  var relevantFilterWidgetIds = (widgets || [])
    .filter(function (widget) {
      return isFilterWidget(widget);
    })
    .filter(function (filterWidget) {
      var filterContainers = scopes.widgetScopeMap[filterWidget.id] || [];

      if (targetContainerIds.length === 0 && filterContainers.length === 0) {
        return true;
      }

      return filterContainers.some(function (containerId) {
        return targetContainerIds.includes(containerId);
      });
    })
    .map(function (widget) {
      return widget.id;
    });

  return collectMergedFilterParams(relevantFilterWidgetIds, filterValuesByWidgetId || {});
}
